import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { getDashboard, getRulebookData, download_Rulebook } from "../services/dashboard.services";
import AddIcon from "@mui/icons-material/Add";
import DashboardValidationReports from "./DashboardValidationReports";

const Dashbord = () => {
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState<any[]>([]);
  const [rulebookAvailable, setRulebookAvailable] = useState(false);
  const [showPayrollUploadDiv,setShowPayrollUploadDiv] = useState(false);

  const handleButtonClick = () => {
    navigate('/rule'); // Route to the /about page
  };
  const handleViewRulebook = async () => {
    const rulebookData = await getRulebookData();
    navigate('/rulebook', { state: rulebookData });
  }
  const handleValidateNewPayroll = () => {
    navigate("/rule", { state: { activeStep: 2 } });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getDashboard();
        setDashboardData(res?.data || []);
        const rulebookData = await getRulebookData();
        if (rulebookData && rulebookData.length > 0) {
          setRulebookAvailable(true);
          if(res.data.length > 0){
            setShowPayrollUploadDiv(true);
          }
        }

      } catch (error: any) {
        console.error("Dashboard error:", error.message);
        // navigate("/login", { replace: true });
      }
    };
    fetchData();
    const handleNewNotification = (event: Event) => {
      const customEvent = event as CustomEvent<{ status: string }>;
      const status = customEvent.detail?.status || "";

      if (
        status === "success" || status === "failed"
      ) {
        fetchData(); 
      }
    };

    window.addEventListener("newNotification", handleNewNotification);

    return () => {
      window.removeEventListener("newNotification", handleNewNotification);
    };
  }, [navigate]);

  return (
    <>
      <div className="dashboard-page-header-container">
        <div className="left-section">
          <div className="page-heading-section">
            <label className="page-heading">Dashboard</label>
            <p className="page-subheading">Manage rules and view payroll validation reports</p>
          </div>
        </div>
        {/* <div className="right-section">
          <button className="right-button" onClick={onRightButtonClick}>
            {rightButtonText}
          </button>
          
        </div> */}
        <div className="right-section">
          <Button
            className="right-button"
            variant="contained"
            onClick={handleViewRulebook}
            disabled={!rulebookAvailable}
            sx={{
              textTransform: "none",
              backgroundColor: rulebookAvailable ? "#007CB0" : "#9E9E9E",
              color: "#fff",
              "&.Mui-disabled": {
                backgroundColor: "#9E9E9E",
                color: "#fff",
                opacity: 1,
              },
            }}
          >
            View Rulebooks
          </Button>
        </div>

      </div>
      {rulebookAvailable && dashboardData.length == 0 ? (<>
      <div className="welcome-div">
          <label className="div-txt-heading">Welcome! </label>
          <label className="div-txt-sub-heading">
            An active version of rulebook already available. Proceed with uploading and validating a payroll file.
          </label>
          
          <Button
             variant="outlined" className="welcome-btn"
             sx={{ textTransform: "none", width: '201px !important' }}
             onClick={handleValidateNewPayroll}
            >
              Validate New Payroll
            </Button>
        </div>
      </>) : dashboardData.length > 0 ? (
        <> <DashboardValidationReports reports={dashboardData} />
         </>) : (
       <> <div className="welcome-div">
          <label className="div-txt-heading">Welcome! Let's get started</label>
          <label className="div-txt-sub-heading">
            Begin by uploading your rulebook, then proceed with uploading and validating payroll file
          </label>
          <Button className="welcome-btn" variant="contained" onClick={handleButtonClick}>
            Start
          </Button>
        </div>
      </>
      )}

    </>
  );
};

export default Dashbord;